import styled from "styled-components"

export const StyledAboutContactSection = styled.section`
  width: 100%;
  padding: 0 140px;
  @media only screen and (max-width: 942px) {
    padding: 0 80px;
  }
  @media only screen and (max-width: 834px) {
    padding: 0 40px 0 80px;
  }
  @media only screen and (max-width: 767px) {
    padding: 0 28px;
  }
`
